import React, { PropsWithChildren, useMemo } from 'react';
import styles from '../../AstralWalletTransactionStatusPage.module.scss';
import { CustomButton, CustomIcon } from '@components';
import classNames from 'classnames';
import { MyCheckApp } from 'mycheck-core';
import get from 'lodash/get';

interface FailedStatusWrapperProps {
  title: string;
  primaryBtnLabel: string;
  secondaryBtnLabel: string;
  onPrimaryBtnClick: () => void;
  onSecondaryBtnClick: () => void;
}

export const FailedStatusWrapper: React.FC<
  PropsWithChildren<FailedStatusWrapperProps>
> = ({
  title,
  onPrimaryBtnClick,
  onSecondaryBtnClick,
  primaryBtnLabel,
  secondaryBtnLabel,
  children,
}) => {
  const { primary: colorPrimary } = useMemo(() => {
    const _config = MyCheckApp.instance.getGlobalConfig();
    const primary = get(_config, 'palette.primary', {});

    return {
      primary,
    };
  }, []);

  return (
    <>
      <div className={styles.astralWalletStatusPageContent}>
        <CustomIcon
          style={{ color: colorPrimary }}
          name="warning"
          className={styles.astralWalletStatusPageContentIconWrapper}
        />
        <p
          className={styles.astralWalletStatusPageContentTitle}
          style={{ color: colorPrimary }}
        >
          {title}
        </p>
        {children}
      </div>
      <CustomButton
        className={styles.astralWalletStatusPageButton}
        text={primaryBtnLabel}
        handleButtonClick={onPrimaryBtnClick}
      />
      <CustomButton
        backgroundColor="transparent"
        className={classNames([
          styles.astralWalletStatusPageButton,
          styles.astralWalletStatusPageButtonSecondary,
        ])}
        text={secondaryBtnLabel}
        handleButtonClick={onSecondaryBtnClick}
      />
    </>
  );
};
